export default function Orders() {
  return <div>Đơn hàng của bạn</div>;
}

export {};
